// 路由组件统一懒加载：访问时再加载对应 chunk
const Home = () => import('@/layout/index.vue')
// 师资管理
const teacherManagement = () => import('@/pages/trainingManagement/teacherManagement')
const addTeacher = () => import('@/pages/trainingManagement/addTeacher')
const trainingResource = () => import('@/pages/trainingManagement/trainingResource')
const mallTrainingResource = () => import('@/pages/mall/trainingManagement/trainingResource')
const addProgram = () => import('@/pages/trainingManagement/addProgram')
const latojaManagement = () => import('@/pages/trainingManagement/latojaManagement')
// training task
const trainingTask = () => import('@/pages/trainingManagement/task/trainingTask')
const publishTask = () => import('@/pages/trainingManagement/task/publishTask')
const selectCourse = () => import('@/pages/trainingManagement/task/selectCourse')
const trainingResourceDetail = () => import('@/pages/trainingManagement/trainingResourceDetail')
const mallTrainingResourceDetail = () => import('@/pages/mall/trainingManagement/trainingResourceDetail')
const trainingDetail = () => import('@/pages/trainingManagement/trainingDetail')
const addLatoja = () => import('@/pages/trainingManagement/addLatoja')
const examInfo = () => import('@/pages/trainingManagement/examInfo')
const questionBankManagenment = () => import('@/pages/examination/questionBankManagenment')
const mallQuestionBankManagenment = () => import('@/pages/mall/examination/questionBankManagenment')
const paperManagement = () => import('@/pages/examination/paperManagement')
const mallPaperManagement = () => import('@/pages/mall/examination/paperManagement')
const examManagement = () => import('@/pages/examination/examManagement')
const examStatistics = () => import('@/pages/examination/examStatistics')
const issueExam = () => import('@/pages/examination/issueExam')
const directory = () => import('@/pages/trainingManagement/directory')
const mallDirectory = () => import('@/pages/mall/trainingManagement/directory')
const examStatisticsDetail = () => import('@/pages/examination/examStatisticsDetail')
const addPaper = () => import('@/pages/examination/addPaper')
const mallAddPaper = () => import('@/pages/mall/examination/addPaper')
const addQuestion = () => import('@/pages/examination/addQuestion')
const mallAddQuestion = () => import('@/pages/mall/examination/addQuestion')
// 课程管理
const courseManagement = () => import('@/pages/trainingManagement/course/courseManagement')
const mallCourseManagement = () => import('@/pages/mall/course/courseManagement')
const addCourse = () => import('@/pages/trainingManagement/course/addCourse')
const mallAddCourse = () => import('@/pages/mall/course/addCourse')
// 安全培训计划
const safetyTrainingProgramList = () => import('@/pages/trainingManagement/safetyTrainingProgram/list.vue')
const safetyTrainingProgramDetails = () => import('@/pages/trainingManagement/safetyTrainingProgram/details.vue')
// 培训对象(线上)
const trainingObject = () => import('@/pages/trainingManagement/safetyTrainingProgram/component/trainingObject.vue')
// 培训对象(线下)
const offlineTrainingObjects = () => import('@/pages/trainingManagement/safetyTrainingProgram/component/offlineTrainingObjects.vue')
// 学员前端
const myTrain = () => import('@/pages/student/myTrain')
const myExam = () => import('@/pages/student/myExam')
const train = () => import('@/pages/student/train')
const exam = () => import('@/pages/student/exam')
const lookExam = () => import('@/pages/student/lookExam')
const mallLookExam = () => import('@/pages/mall/student/lookExam')
// 档案管理
const archivesEnterprise = () => import('@/pages/trainingManagement/archives/enterprise/index.vue')
// 一期一档列表页面
const osofList = () => import('@/pages/trainingManagement/archives/osof/osofList.vue')
const osofDir = () => import('@/pages/trainingManagement/archives/osof/osofDir.vue')
// 企业开放课程
const entOpenCourse = () => import('@/pages/trainingManagement/entOpenCourse/index.vue')
const entOpentPlay = () => import('@/pages/trainingManagement/entOpenCourse/play.vue')
// 轮播
const banner = () => import('@/pages/mall/banner/index.vue')
const addBanner = () => import('@/pages/mall/banner/addBanner.vue')
// 订单
const order = () => import('@/pages/mall/order/index.vue')
const orderDetail = () => import('@/pages/mall/order/orderDetail.vue')
// 商城
const wechatMall = () => import('@/pages/mall/wechatMall/index.vue')
const wechatInfo = () => import('@/pages/mall/wechatMall/info.vue')
// 流水
const flowingWater = () => import('@/pages/mall/flowingWater/index.vue')
const enterPrisrBase = () => import('@/pages/mall/flowingWater/enterPrisrBase.vue')
// 充值
const flowingWaterRecharge = () => import('@/pages/mall/flowingWater/recharge.vue')
export default [{
  path: '/',
  component: Home,
  name: '新培训管理',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/mall/trainingManagement/trainingResource',
    component: mallTrainingResource,
    name: '培训资源管理',
    menuShow: true
  },
    {
      path: '/trainingManagement/trainingResource',
      component: trainingResource,
      name: '培训资源管理',
      menuShow: true
    },
    {
      path: '/trainingManagement/latojaManagement',
      component: latojaManagement,
      name: '线下培训管理',
      menuShow: true
    },
    // {
    //   path: '/trainingManagement/safetyTrainingProgramList',
    //   component: safetyTrainingProgramList,
    //   name: '安全培训计划',
    //   menuShow: true
    // },
    // {
    //   path: '/trainingManagement/safetyTrainingProgramSave',
    //   component: safetyTrainingProgramSave,
    //   name: '安全培训计划',
    //   menuShow: true,
    //   meta: {  activeMenu: '/trainingManagement/safetyTrainingProgramList' },
    // },
    {
      path: '/safetyTrainingProgram/details',
      component: safetyTrainingProgramDetails,
      name: '计划详情',
      menuShow: true,
      meta: {  activeMenu: '/trainingManagement/safetyTrainingProgramList' },
    },
    {
      path: '/safetyTrainingProgram/details/trainingObject',
      component: trainingObject,
      name: '培训对象',
      menuShow: true
    },
    {
      path: '/safetyTrainingProgram/details/offlineTrainingObjects',
      component: offlineTrainingObjects,
      name: '培训对象',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingTask',
      component: trainingTask,
      name: '培训任务',
      menuShow: true
    },
    {
      path: '/trainingManagement/pushList',
      component: () => import('@/pages/trainingManagement/tpush/pushList.vue'),
      name: '推送管理',
      menuShow: true
    },
    {
      path: '/trainingManagement/pushEnt',
      component: () => import('@/pages/trainingManagement/tpush/pushEnt.vue'),
      name: '政府推送',
      menuShow: true
    },
    {
      path: '/trainingManagement/offlineTrainingTasks',
      component: () => import('@/pages/trainingManagement/safetyTrainingProgram/component/offlineTrainingTasks'),
      name: '线下培训任务',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingResourceDetail',
      component: trainingResourceDetail,
      name: '课件详情',
      menuShow: true,
      meta: {    activeMenu: '/trainingManagement/trainingResource' },
    },
    {
      path: '/trainingManagement/trainingResourceAdd',
      component: trainingResourceDetail,
      name: '新增课件',
      menuShow: true,
      meta: {activeMenu: '/trainingManagement/trainingResource' },
    },
    {
      path: '/mall/trainingManagement/trainingResourceAdd',
      component: mallTrainingResourceDetail,
      name: '新增课件',
      menuShow: true,
      meta: {activeMenu: '/mall/trainingManagement/trainingResource' },
    },
    {
      path: '/trainingManagement/trainingResourceUpdate',
      component: trainingResourceDetail,
      name: '编辑课件',
      menuShow: true,
      meta: {activeMenu: '/trainingManagement/trainingResource' },
    },
    {
      path: '/mall/trainingManagement/trainingResourceUpdate',
      component: mallTrainingResourceDetail,
      name: '编辑课件',
      menuShow: true,
      meta: {activeMenu: '/mall/trainingManagement/trainingResource' },
    },
    {
      path: '/trainingManagement/addProgram',
      component: addProgram,
      name: '添加培训计划',
      menuShow: true
    },
    {
      path: '/trainingManagement/task/publishTask',
      component: publishTask,
      name: '下发任务',
      menuShow: true,
      meta: {activeMenu: '/trainingManagement/trainingTask' },

    },
    {
      path: '/trainingManagement/task/selectCourse',
      component: selectCourse,
      name: '选择下发课程',
      menuShow: true
    },
    {
      path: '/trainingManagement/trainingDetail',
      component: trainingDetail,
      name: '培训任务详情',
      menuShow: true
    },
    {
      path: '/trainingManagement/addLatoja',
      component: addLatoja,
      name: '添加线下培训',
      menuShow: true,
      meta: {  activeMenu: '/trainingManagement/latojaManagement' },
    },
    {
      path: '/trainingManagement/detailLatoja',
      component: addLatoja,
      name: '线下培训详情',
      menuShow: true,
      meta: {  activeMenu: '/trainingManagement/latojaManagement' },
    },
    {
      path: '/trainingManagement/updateLatoja',
      component: addLatoja,
      name: '编辑线下培训',
      menuShow: true,
      meta: {  activeMenu: '/trainingManagement/latojaManagement' },
    },
    {
      path: '/trainingManagement/examInfo',
      component: examInfo,
      name: '关联考试信息',
      menuShow: true
    },
  ]
}, {
  path: '/',
  component: Home,
  name: '安全教育考试',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/examination/questionBankManagenment',
    component: questionBankManagenment,
    name: '试题管理',
    menuShow: true
  }, {
    path: '/mall/examination/questionBankManagenment',
    component: mallQuestionBankManagenment,
    name: '题库管理',
    menuShow: true
  },
    {
      path: '/examination/paperManagement',
      component: paperManagement,
      name: '试卷管理',
      menuShow: true
    }, {
      path: '/mall/examination/paperManagement',
      component: mallPaperManagement,
      name: '试卷管理',
      menuShow: true
    },
    {
      path: '/examination/examManagement',
      component: examManagement,
      name: '考试管理',
      menuShow: true
    },
    {
      path: '/examination/examStatistics',
      component: examStatistics,
      name: '考试统计',
      menuShow: true
    },
    {
      path: '/examination/examStatisticsDetail',
      component: examStatisticsDetail,
      name: '考试统计详情',
      menuShow: true,
      meta: {  activeMenu: '/examination/examStatistics' },
    },
    {
      path: '/examination/addPaper',
      component: addPaper,
      name: '试卷信息',
      menuShow: true,
      meta: {activeMenu: '/examination/paperManagement' },
    },
    {
      path: '/mall/examination/addPaper',
      component: mallAddPaper,
      name: '试卷信息',
      menuShow: true,
      meta: {activeMenu: '/mall/examination/paperManagement' },
    },
    {
      path: '/examination/addQuestion',
      component: addQuestion,
      name: '新建题库',
      menuShow: true,
      meta: {   activeMenu: '/examination/questionBankManagenment' },
    }, {
      path: '/mall/examination/addQuestion',
      component: mallAddQuestion,
      name: '新建题库',
      menuShow: true,
      meta: {   activeMenu: '/mall/examination/questionBankManagenment' },
    },
    {
      path: '/examination/detailQuestion',
      component: addQuestion,
      name: '题库详情',
      menuShow: true,
      meta: {   activeMenu: '/examination/questionBankManagenment' },
    },
    {
      path: '/mall/examination/detailQuestion',
      component: mallAddQuestion,
      name: '题库详情',
      menuShow: true,
      meta: {   activeMenu: '/mall/examination/questionBankManagenment' },
    },
    {
      path: '/examination/updateQuestion',
      component: addQuestion,
      name: '编辑题库',
      menuShow: true,
      meta: {   activeMenu: '/examination/questionBankManagenment' },
    }, {
      path: '/mall/examination/updateQuestion',
      component: mallAddQuestion,
      name: '编辑题库',
      menuShow: true,
      meta: {   activeMenu: '/mall/examination/questionBankManagenment' },
    },
    {
      path: '/examination/issueExam',
      component: issueExam,
      name: '发布考试',
      menuShow: true,
      meta: {   activeMenu: '/examination/examManagement' },
    }, {
      path: '/examination/directory',
      component: directory,
      name: '目录',
      menuShow: true
    }, {
      path: '/mall/examination/directory',
      component: mallDirectory,
      name: '目录',
      menuShow: true
    }, {
      path: '/trainingManagement/teacherManagement',
      component: teacherManagement,
      name: '师资管理',
      menuShow: true
    }, {
      path: '/trainingManagement/detailTeacher',
      component: addTeacher,
      name: '师资信息',
      menuShow: true,
      meta: { activeMenu: '/trainingManagement/teacherManagement' },
    },
    {
      path: '/trainingManagement/addTeacher',
      component: addTeacher,
      name: '新建师资',
      menuShow: true,
      meta: { activeMenu: '/trainingManagement/teacherManagement' },
    },
    {
      path: '/trainingManagement/updateTeacher',
      component: addTeacher,
      name: '编辑师资',
      menuShow: true,
      meta: { activeMenu: '/trainingManagement/teacherManagement' },
    }, {
      path: '/mall/course/courseManagement',
      component: mallCourseManagement,
      name: '课程管理',
      menuShow: true,
    }, {
      path: '/examination/course/courseManagement',
      component: courseManagement,
      name: '课程管理',
      menuShow: true
    }, {
      path: '/examination/course/addCourse',
      component: addCourse,
      name: '新增课程',
      menuShow: true,
      meta: {  activeMenu: '/examination/course/courseManagement' },
    }, {
      path: '/mall/examination/course/addCourse',
      component: mallAddCourse,
      name: '新增课程',
      menuShow: true,
      meta: {  activeMenu: '/mall/course/courseManagement' },
    }, {
      path: '/examination/course/updateCourse',
      component: addCourse,
      name: '编辑课程',
      menuShow: true,
      meta: {  activeMenu: '/examination/course/courseManagement' },
    }, {
      path: '/mall/examination/course/updateCourse',
      component: mallAddCourse,
      name: '编辑课程',
      menuShow: true,
      meta: {  activeMenu: '/mall/course/courseManagement' },
    }, {
      path: '/examination/course/detailCourse',
      component: addCourse,
      name: '课程信息',
      menuShow: true,
      meta: {  activeMenu: '/examination/course/courseManagement' },
    }, {
      path: '/mall/examination/course/detailCourse',
      component: mallAddCourse,
      name: '课程信息',
      menuShow: true,
      meta: {  activeMenu: '/mall/course/courseManagement' },
    }
  ]
}, {
  path: '/',
  component: Home,
  name: '档案管理',
  menuShow: true,
  leaf: true,
  children: [
    {
      path: '/archives/ent',
      component: archivesEnterprise,
      name: '企业档案',
      menuShow: true
    },
    {
      path: '/archives/ent/overall',
      // component: osofDir,
      component: () => import('@/pages/trainingManagement/archives/overall/index.vue'),
      name: '一人一档',
      menuShow: true
    },
    {
      path: '/archives/osof/list',
      component: osofList,
      name: '一期一档',
      menuShow: true
    },
    {
      path: '/archives/osof/dir',
      component: osofDir,
      name: '档案目录',
      menuShow: true,
      meta: {  activeMenu: '/archives/osof/list' },
    },
    {
      path: '/archives/personage',
      // component: osofDir,
      component: () => import('@/pages/trainingManagement/archives/personage/index.vue'),
      name: '一人一档',
      menuShow: true
    },
    {
      path: '/archives/personage-noe',
      component: () => import('@/pages/trainingManagement/archives/personage/personage-noe.vue'),
      name: '一人一档',
      menuShow: true
    },
    {
      path: '/archives/calss/record',
      component: () => import('@/pages/trainingManagement/archives/class/oneIssue.vue'),
      name: '一期一档',
      menuShow: true
    },
    {
      path: '/archives/calss/osof/dir',
      component: () => import('@/pages/trainingManagement/archives/class/dir/osofDir.vue'),
      name: '一期一档目录',
      menuShow: true
    },
    {
      path: '/archives/personage/one',
      // component: osofDir,
      component: () => import('@/pages/trainingManagement/archives/personage/one.vue'),
      name: '一人一档',
      menuShow: true
    }
  ]
},
  {
    path: '/',
    component: Home,
    name: '学员',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/student/myTrain',
      component: myTrain,
      name: '我的培训',
      menuShow: true
    },
      {
        path: '/student/myExam',
        component: myExam,
        name: '我的考试',
        menuShow: true
      },
    ]
  },
  {
    path: '/student/train',
    component: train,
    name: '开始学习',
    leaf: true,
    menuShow: true
  },
  {
    path: '/student/exam',
    component: exam,
    name: '开始考试'
  },
  {
    path: '/student/lookExam',
    component: lookExam,
    name: '查看试卷'
  }, {
    path: '/mall/student/lookExam',
    component: mallLookExam,
    name: '查看试卷'
  },

  {
    path: '/',
    component: Home,
    name: '开放资源',
    menuShow: true,
    leaf: true,
    children: [
      //开放课程
      {
        path: '/ent-open/course',
        component: entOpenCourse,
        name: '开放课程',
        menuShow: true
      },
      //播放视频 （针对开放课程）
      {
        path: '/ent-open/play',
        component: entOpentPlay,
        name: '视频播放',
        menuShow: true
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '轮播图管理',
    menuShow: true,
    leaf: true,
    children: [
      //开放课程
      {
        path: '/mall/banner/index',
        component: banner,
        name: '轮播图列表',
        menuShow: true
      },
      {
        path: '/mall/banner/addBanner',
        component: addBanner,
        name: '添加轮播图',
        menuShow: true,
        meta: {  activeMenu: '/mall/banner/index' },
      },
      {
        path: '/mall/banner/updateBanner',
        component: addBanner,
        name: '修改轮播图',
        menuShow: true,
        meta: {  activeMenu: '/mall/banner/index' },
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '订单管理',
    menuShow: true,
    leaf: true,
    children: [
      //开放课程
      {
        path: '/mall/order/index',
        component: order,
        name: '订单列表',
        menuShow: true
      },
      {
        path: '/mall/order/orderDetail',
        component: orderDetail,
        name: '订单详情',
        menuShow: true,
        meta: {  activeMenu: '/mall/order/index' },
      },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '商城管理',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/mall/wechatMall/index',
      component: wechatMall,
      name: '商城列表',
      menuShow: true,
      meta: {
        group: 'mall'
      },
    }]
  },   {
    path: '/',
    component: Home,
    name: '平台课程',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/course/platform',
      component: wechatMall,
      name: '平台课程',
      menuShow: true,
    }]
  },{
    path: '/',
    component: Home,
    name: '订单流水管理',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/mall/flowingWater/index',
      component: flowingWater,
      name: '企业订单流水管理',
      menuShow: true
    },
      {
        path: '/mall/flowingWater/enterPrisrBase',
        component: enterPrisrBase,
        name: '平台订单流水管理',
        menuShow: true
      },
      {
        path: '/mall/flowingWater/recharge',
        component: flowingWaterRecharge,
        name: '企业充值',
        menuShow: true
      }
    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/newRouter.js